module.exports = __webpack_public_path__ + "img/zixun2@2x.b7c66bfa.png";